// extracted by mini-css-extract-plugin
module.exports = {"otp":"otp___1gFxZ","btnBox":"btnBox___jB1BS","otpCon":"otpCon___mDubv","sendOtpBtn":"sendOtpBtn___Qhafg"};